module.exports = __webpack_public_path__ + "images/the-main-event-cdc2663ef265244cf822a353b7134376.png";